export interface PickedAsset {
  uri: string;
  type: string;
  name: string;
  webFile?: File;
}

const pickFile = (capture: boolean): Promise<PickedAsset | null> => {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    if (capture) input.setAttribute('capture', 'environment');
    input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (!file) { resolve(null); return; }
      resolve({
        uri: URL.createObjectURL(file),
        type: file.type || 'image/jpeg',
        name: file.name,
        webFile: file,
      });
    });
    // Supported in current Chrome/Edge/Safari — resolves the promise if the user
    // dismisses the native file picker without choosing a file.
    input.addEventListener('cancel', () => resolve(null));
    input.click();
  });
};

export const pickFromCamera = (): Promise<PickedAsset | null> => pickFile(true);
export const pickFromLibrary = (): Promise<PickedAsset | null> => pickFile(false);
